import React from 'react';
import { useNavigate } from 'react-router-dom';
import './NewsAndGuidesPage.css';

export default function NewsAndGuidesPage() {
  const navigate = useNavigate();

  const newsItems = [
  {
    id: 0,
    title: "Bug-Sized Robots Flex Their Muscles",
    snippet: "Tiny robots powered by muscle-inspired actuators are crawling, swimming, and jumping into the future.",
    link: "/news/bugbots",
    category: "News"
  },
  {
    id: 1,
    title: "Welcome to ChronoTech – Our Mission & Vision",
    snippet: "Why we created Robo Kids and what we hope to build for the next generation.",
    link: "/news/welcome",
    category: "News"
  },
  {
    id: 2,
    title: "Website Safety & Security for Parents",
    snippet: "Learn about the safety steps we take to protect your family and your data.",
    link: "/news/security-basics",
    category: "News"
  },
  {
    id: 3,
    title: "Fall Class Launch: New Dates, Kits & Upgrades",
    snippet: "Everything new coming in Fall 2025 for each of our 4 levels.",
    link: "/news/fall-launch",
    category: "News"
  }
];

  const guideItems = [
    {
      id: 1,
      title: "How to Wire a Light Switch",
      snippet: "Step-by-step guide to safely connecting and controlling LED lights in your robot projects.",
      link: "/guides/light-switch",
      category: "Guide"
    },
    {
      id: 2,
      title: "How to Wire a Motor",
      snippet: "Learn the basics of motor wiring and control for your robotic creations.",
      link: "/guides/motor-guide",
      category: "Guide"
    },
    {
      id: 3,
      title: "How to Wire a Servo Motor",
      snippet: "Master servo motor connections for precise movement control in your robots.",
      link: "/guides/servo-guide",
      category: "Guide"
    }
  ];

  const handleItemClick = (link) => {
    navigate(link);
  };

  return (
    <div className="news-guides-container">
      <h1>News & Robot Guides</h1>
      <p className="description">
        Stay updated with ChronoTech news, blog posts, and robotics tips. 
        Browse our growing collection of beginner-friendly tutorials and projects below.
      </p>

      {/* News Section */}
      <section className="section">
        <h2 className="section-title"> Latest News & Blog</h2>
        <div className="items-grid">
          {newsItems.map((item) => (
            <div 
              key={item.id} 
              className="item"
              onClick={() => handleItemClick(item.link)}
            >

              
              <div className="item-details">
                <div className="category-badge">{item.category}</div>
                <h3>{item.title}</h3>
                <p className="snippet">{item.snippet}</p>
                <button className="read-more-btn">
                  Read More
                </button>
              </div>
            </div>
          ))}
        </div>
      </section>

      {/* Guides Section */}
      <section className="section">
        <h2 className="section-title"> Robot Guides</h2>
        <div className="items-grid">
          {guideItems.map((item) => (
            <div 
              key={item.id} 
              className="item"
              onClick={() => handleItemClick(item.link)}
            >
              <div className="item-details">
                <div className="category-badge">{item.category}</div>
                <h3>{item.title}</h3>
                <p className="snippet">{item.snippet}</p>
                <button className="read-more-btn">
                  View Guide
                </button>
              </div>
            </div>
          ))}
        </div>
      </section>
    </div>
  );
}